import { ChangeEventHandler } from 'react'
import { useTranslation } from 'react-i18next'
import { PositionXYPX } from '../../types/PositionXY'

type Props = {
  onSwitch: ChangeEventHandler<HTMLInputElement>
  isOn?: boolean
  position?: PositionXYPX
}

const CheckboxSwitch = ({ onSwitch, isOn, position }: Props) => {
  const { t } = useTranslation()

  return (
    <div
      className="absolute z-[110] -translate-y-1/2 animate-[simple-fade-in_0.2s]"
      style={{
        top: position ? position.y : '10%',
        left: position ? position.x : 'calc(50% + 500px + 2rem)',
      }}
    >
      <p className="m-0 mb-[14px]">{t('freehandGeneratorMirroring')}</p>
      <label className="relative inline-block h-[40px] w-[64px]">
        <input
          className="peer size-0 opacity-0"
          type="checkbox"
          checked={isOn}
          onChange={onSwitch}
        />
        <span className="absolute inset-0 h-[30px] cursor-pointer rounded-[34px] bg-black [transition:0.4s] before:absolute before:-left-[10px] before:-top-[5px] before:size-[40px] before:rounded-full before:bg-[#ebedef] before:shadow-[0_4px_6px_0_rgba(0,0,0,0.5)] before:content-[''] before:[transition:0.4s] peer-checked:before:translate-x-[42px] peer-checked:before:bg-red"></span>
      </label>
    </div>
  )
}

export default CheckboxSwitch
